import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import style from './Navbar.module.css';

import { FitnessCategory } from "../https/http";
const Navbar = () => {
  const [open, setOpen] = useState(false);          
  const [dropdownOpen, setDropdownOpen] = useState(false); 
  const [video, setVideo] = useState([]);

  useEffect(() => {
  const fetchVideos = async () => {
    try {
      const res = await FitnessCategory();
      setVideo(res.data?.data?.videos || []);
    } catch (error) {
      console.error("API Error:", error);
      setVideo([]);
    }
  };

  fetchVideos();
}, []);

  return (
    <nav className={style.navbar}>
    
      {/* <div className={style.logo}>Fitness</div> */}
<div className={style.logo}>
  <img src="../../assets/images/fitnessplex.png" alt="FitnessPlex Logo" />
</div>
      
      <div
        className={style.menu_icon}
        onClick={() => setOpen(!open)}
      >
        ☰
      </div>

     
      <ul className={`${style.nav_links} ${open ? style.open : ''}`}>
        <li>
          <Link to="/" onClick={() => setOpen(false)}>Home</Link>
        </li>

        <li>
          <Link to="/about" onClick={() => setOpen(false)}>About</Link>
        </li>

        <li
          className={style.category_wrapper}
          onClick={() => setDropdownOpen(!dropdownOpen)}
        >
          Category

          {dropdownOpen && (
            <ul className={style.dropdown}>
              {video.map((item, index) => (
                <li key={index}>
                  <Link
                    to={`/${item.category.toLowerCase()}/${item.id}`}
                    onClick={() => {
                      setDropdownOpen(false);
                      setOpen(false);
                    }}
                  >
                    {item.category}
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </li>

        <li>
          <Link to="/profile" onClick={() => setOpen(false)}>Profile</Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
